import { NgModule } from '@angular/core';
import {
  AnonymousConsentsModule,
  AuthModule,
  CostCenterOccModule,
  ExternalRoutesModule,
  ProductModule,
  ProductOccModule,
  provideFeatureToggles,
  UserModule,
  UserOccModule,
} from '@spartacus/core';
import {
  AnonymousConsentManagementBannerModule,
  AnonymousConsentsDialogModule,
  BannerCarouselModule,
  BannerModule,
  BreadcrumbModule,
  CategoryNavigationModule,
  CmsParagraphModule,
  ConsentManagementModule,
  FooterNavigationModule,
  HamburgerMenuModule,
  HomePageEventModule,
  LinkModule,
  LoginRouteModule,
  LogoutModule,
  MyAccountV2Module,
  MyCouponsModule,
  MyInterestsModule,
  NavigationEventModule,
  NavigationModule,
  NotificationPreferenceModule,
  PageTitleModule,
  PaymentMethodsModule,
  PDFModule,
  ProductCarouselModule,
  ProductDetailsPageModule,
  ProductFacetNavigationModule,
  ProductImagesModule,
  ProductIntroModule,
  ProductListingPageModule,
  ProductListModule,
  ProductPageEventModule,
  ProductReferencesModule,
  ProductSummaryModule,
  ProductTabsModule,
  ScrollToTopModule,
  SearchBoxModule,
  SiteContextSelectorModule,
  SiteThemeSwitcherModule,
  StockNotificationModule,
  TabParagraphContainerModule,
  VideoModule,
} from '@spartacus/storefront';
import { UserFeatureModule } from './features/user/user-feature.module';
import { CartBaseFeatureModule } from './features/cart/cart-base-feature.module';
import { CartSavedCartFeatureModule } from './features/cart/cart-saved-cart-feature.module';
import { WishListFeatureModule } from './features/cart/wish-list-feature.module';
import { CartQuickOrderFeatureModule } from './features/cart/cart-quick-order-feature.module';
import { CartImportExportFeatureModule } from './features/cart/cart-import-export-feature.module';
import { OrderFeatureModule } from './features/order/order-feature.module';
import { CheckoutFeatureModule } from './features/checkout/checkout-feature.module';
import { PersonalizationFeatureModule } from './features/tracking/personalization-feature.module';
import { StoreFinderFeatureModule } from './features/storefinder/store-finder-feature.module';
import { AsmFeatureModule } from './features/asm/asm-feature.module';
import { AsmCustomer360FeatureModule } from './features/asm/asm-customer360-feature.module';
import { SmartEditFeatureModule } from './features/smartedit/smart-edit-feature.module';
import { ProductVariantsFeatureModule } from './features/product/product-variants-feature.module';
import { ProductImageZoomFeatureModule } from './features/product/product-image-zoom-feature.module';

@NgModule({
  declarations: [],
  imports: [
    AuthModule.forRoot(),
    LogoutModule,
    LoginRouteModule,
    HamburgerMenuModule,
    SiteContextSelectorModule,
    LinkModule,
    BannerModule,
    CmsParagraphModule,
    TabParagraphContainerModule,
    BannerCarouselModule,
    CategoryNavigationModule,
    NavigationModule,
    FooterNavigationModule,
    BreadcrumbModule,
    ScrollToTopModule,
    PageTitleModule,
    VideoModule,
    PDFModule,
    SiteThemeSwitcherModule,
    UserModule,
    UserOccModule,
    PaymentMethodsModule,
    NotificationPreferenceModule,
    MyInterestsModule,
    MyAccountV2Module,
    StockNotificationModule,
    ConsentManagementModule,
    MyCouponsModule,
    AnonymousConsentsModule.forRoot(),
    AnonymousConsentsDialogModule,
    AnonymousConsentManagementBannerModule,
    ProductModule.forRoot(),
    ProductOccModule,
    ProductDetailsPageModule,
    ProductListingPageModule,
    ProductListModule,
    SearchBoxModule,
    ProductFacetNavigationModule,
    ProductTabsModule,
    ProductCarouselModule,
    ProductReferencesModule,
    ProductImagesModule,
    ProductSummaryModule,
    ProductIntroModule,
    CostCenterOccModule,
    NavigationEventModule,
    HomePageEventModule,
    ProductPageEventModule,
    ExternalRoutesModule.forRoot(),
    UserFeatureModule,
    CartBaseFeatureModule,
    CartSavedCartFeatureModule,
    WishListFeatureModule,
    CartQuickOrderFeatureModule,
    CartImportExportFeatureModule,
    OrderFeatureModule,
    CheckoutFeatureModule,
    PersonalizationFeatureModule,
    StoreFinderFeatureModule,
    AsmFeatureModule,
    AsmCustomer360FeatureModule,
    SmartEditFeatureModule,
    ProductVariantsFeatureModule,
    ProductImageZoomFeatureModule,
  ],
  providers: [
    provideFeatureToggles({
      a11yKeyboardAccessibleZoom: true,
      a11yPreventCartItemsFormRedundantRecreation: true,
      a11yStoreFinderLabel: true,
      a11yLinkBtnsToTertiaryBtns: true,
      a11yAddPaddingToCarouselPanel: true,
      a11yNgSelectUnicodeCarets: true,
      readMoreDirective: true,
      productReviewCharactersLeft: true,
      a11yNgSelectAriaControls: true,
      a11yConfiguratorOverviewHeaderVPC: true,
      a11yFutureStockAccordionAriaControls: true,
      enableReadDomainValuesOnDemand: true,
      storeFinderFacadeCleanup: true,
      defaultProductPageRouteAllowsNoProductName: true,
      consistentSizeProductCards: true,
      reserveHorizontalSpaceStarRating: true,
      topProgressBarUseTransformAnimation: true,
      disableCxPageSlotMarginAnimation: true,
      productCarouselScrolling: true,
      cdsLoginEventsToken: false,
      createMediaPreconnectLink: true,
      unifiedDefaultHeaderSlotsAcrossBreakpoints: true,
      reserveSpaceForImagesOnPdpAndPlp: true,
      lazyLoadImagesByDefault: true,
      authorizationCodeFlowByDefault: false,
      incrementProcessesCountForMergeCart: false,
      dispatchLoginActionOnlyWhenTokenReceived: false,
      defaultLayoutConfigWithoutPageFold: true,
      navigationMenuCloseOnSameLinkClick: true,
      enablePasswordExpiredErrorTranslation: true,
      enableQuotePurchaseOrderNumber: true,
      enableReturnOrderReturnableQuantityConsigmentFallback: true,
      enableMediaPrefix: true,
      a11yCustomerTicketingVisualFocusFix: true,
      a11yFacetFilterByLabel: true,
      removeDuplicatedOrderHistoryHeader: true,
      a11yCardNotificationMessage: true,
      enableB2BUnitSearch: true,
      enableB2BCostCenterSearch: true,
      enableB2BCustomerSearch: true,
      a11yCarouselPreventNavigationFocus: true,
      a11yNgSelectReadonlyInputValue: true,
      a11yPasswordVisibilityToggle: true,
      showOnlyActiveCurrencies: true,
      a11yAddedToCartDialogHeading: true,
      a11yListSemanticsForFacets: true,
      a11yCartItemListHideEmptyOutlets: true,
      a11yReviewsKeyboardControls: true,
      a11yCartQuickOrderFormEnableSubmitAndAddValidation: true,
      a11yConsentManagementFocusPreservation: true,
      a11yVocalizeDropdownItemCount: true,
      useEnhancedSecurePasswordValidators: true,
      enableRemoveVoucherEndpoint: true,
      showRequiredAsterisks: true,
      enableExpiredRefreshTokenHandlers: true,
    }),
  ],
})
export class SpartacusFeaturesModule {}
